module.exports = __webpack_public_path__ + "8e342c3af89197153a17ee06ffb14dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-bg/blurred-bg-7.jpg
// module id = 380
// module chunks = 0